// LatestNews.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLatestNewsDetails } from "../redux/actions/latestnewsActions";
import { FaSpinner } from "react-icons/fa";

const LatestNews = () => {
  const dispatch = useDispatch();
  const { loading, news, error } = useSelector((s) => s.latestNews);

  useEffect(() => {
    dispatch(getLatestNewsDetails());
  }, [dispatch]);

  return (
    <section className="py-10 px-4 lg:px-16">
      <h2 className="text-3xl font-bold mb-6">Latest News</h2>

      {loading ? (
        <div className="flex justify-center items-center gap-2 text-pink-600">
          <FaSpinner className="animate-spin" /> Loading...
        </div>
      ) : error ? (
        <div className="text-red-500 text-center">{error}</div>
      ) : !news.length ? (
        <p className="text-gray-500 text-center">No latest news available.</p>
      ) : (
        <div className="space-y-12">
          {news.map(({ news_id, image_url, headline, description }) => (
            <div
              key={news_id}
              className="flex flex-col md:flex-row gap-8 items-start border-b pb-8"
            >
              {/* IMAGE: 2/5 width, fixed height */}
              <div className="w-full h-2/3 md:w-1/4">
                <img
                  loading="lazy"
                  src={image_url}
                  alt={headline}
                  className="w-full object-cover rounded-md shadow-md"
                />
              </div>

              {/* TEXT: 3/5 width */}
              <div className="w-full md:w-3/5">
                <span className="inline-block text-xs font-semibold text-[#EA4B4B] bg-[#EBE9F6] px-4 py-2 rounded mb-3">
                  Latest Update
                </span>
                <h3 className="text-7xl md:text-7xl font-bold mb-3">
                  {headline}
                </h3>
                <p className="text-xl text-gray-700 italic leading-relaxed whitespace-pre-line">
                  {description}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default LatestNews;
